import React, { useState } from 'react'
import './styles.scss'
import close from './../../images/close-white.svg'
import Heading from './../heading/Heading';
import Text from './../text/Text';
import loading from './../../images/loading-white-ico.svg';
import arrow from './../../images/arrow.svg';

const ModalLastStep = ( props ) => {
    let [ blockedBtn, setBlockedBtn ] = useState(false);

    const clickedBtn = async () => {
        console.log('click btn modal')
        await setBlockedBtn(true);
        await props.setFunction();
    }
    return (
        <div className="static-modal">
            <div className="modal extra-small max-width">
                <div className="last-step">
                    <div className="icons-wrap">
                        <img src={ close } alt="Zamknij" onClick={ () => props.closeModal() } />
                    </div>
                    <div className="content">
                        <Heading title={`WAŻNE !`} />
                        <Text text={`Zaraz wykonasz identyfikację danych <strong>za pośrednictwem BROKER ID</strong> (dostawca Autenti na zlecenie GRENKE)`} />
                        <Text text={`Przeprowadź ją korzystając <strong>koniecznie z konta firmowego Wnioskodawcy.</strong>`} />
                        <Text text={`Zwróć również uwagę na wybór odpowiedniej metody obsługującej Twój bank.`} />
                        <div className="btn-wrap end">
                            <div className={"btn blue" + (props.finishLoading ? ' loading' : '')}  onClick={ () => !blockedBtn && clickedBtn() }>
                                <span> { props.btnText } </span>
                                <img className="upload-ico" src={ (props.finishLoading ? loading : arrow) } alt="finish form"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalLastStep;